import { tab as Heat } from '../../../hotel/heat/route.config.ts';
import { tab as Help } from '../../../hotel/help/route.config.ts';
import { tab as Intro } from '../../../hotel/intro/route.config.ts';
import { tab as Volume } from '../../../hotel/volume/route.config.ts';

export const tabItems: {
  label: string;
  icon: string;
  to: {
    name: string;
  };
  replace?: boolean;
}[] = [
  Intro,
  {
    label: '领取记录',
    icon: 'clock-o',
    to: {
      name: 'hotel-reports',
    },
    replace: false,
  },
  Heat,
  Volume,
  Help,
];
